'use client';

import { Suspense } from 'react';
import { Box } from '@mui/material';
import { tableContainerStyle } from '@/styles/tableStyles';
import ReaxFFView from '@/components/tables/reaxff/ReaxFFView';

export default function ReaxFFTablePage() {
  return (
    <Box sx={{ ...tableContainerStyle, display: 'flex', flexDirection: 'column' }}>
      <Suspense fallback={<div>Loading...</div>}>
        <ReaxFFView />
      </Suspense>
    </Box>
  );
}
